import React from 'react';
import styled from 'styled-components';
import { VocabularyItem as VocabularyItemType } from '../../types/api';
import MotionLiquidButton from '../../components/MotionLiquidButton';

interface VocabularyListProps {
    vocabularyData: VocabularyItemType[];
    apiError: string;
    onRefresh: () => void;
}

const Container = styled.div`
    /* Main container styles */
`;

const ErrorMessage = styled.div`
    color: #7c2d82;
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 15px;
    background: linear-gradient(135deg, #f3e8ff 0%, #faf5ff 100%);
    border: 2px solid #d8b4fe;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(168, 85, 247, 0.15);
`;

const Title = styled.h3`
    margin-bottom: 20px;
    margin-top: 0;
    color: #6b46c1;
    font-size: 1.8rem;
    text-align: center;
    text-shadow: 0 2px 4px rgba(107, 70, 193, 0.2);
`;

const VocabularyListContainer = styled.div`
    /* Container for the vocabulary list */
`;

const VocabularyItemsList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
`;

const VocabularyItem = styled.li`
    padding: 10px;
    margin-bottom: 8px;
    background-color: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
`;

const JapaneseWord = styled.strong`
    color: #6b46c1;
    margin-right: 15px;
    font-size: 1.1rem;
`;

const EnglishWord = styled.span`
    color: #8b5cf6;
    font-weight: 500;
`;

const RefreshButtonContainer = styled.div`
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
`;

const VocabularyList: React.FC<VocabularyListProps> = ({ vocabularyData, apiError, onRefresh }) => {
    // Handle button click with animation
    const handleRefreshClick = () => {
        // Call the actual refresh function
        onRefresh();
    };

    return (
        <Container>
            <RefreshButtonContainer>
                <MotionLiquidButton variant="glow" onClick={handleRefreshClick}>
                    Refresh Vocabulary List
                </MotionLiquidButton>
            </RefreshButtonContainer>

            {apiError && (
                <ErrorMessage>
                    <strong>Error:</strong> {apiError}
                </ErrorMessage>
            )}
            {vocabularyData.length > 0 && (
                <VocabularyListContainer>
                    <Title>Vocabulary Data Loaded ({vocabularyData.length} items)</Title>
                    <VocabularyItemsList>
                        {vocabularyData.map((item) => (
                            <VocabularyItem key={item.japanese}>
                                <JapaneseWord>{item.japanese}</JapaneseWord> -{' '}
                                <EnglishWord>{item.english}</EnglishWord>
                            </VocabularyItem>
                        ))}
                    </VocabularyItemsList>
                </VocabularyListContainer>
            )}
        </Container>
    );
};

export default VocabularyList;
